import styles from './MainOurPress.module.scss'
import MainOurPressContentBox from './MainOurPressContentBox'
import { OUR_PRESS_DATA } from './dummyData'
import OurPressDataType from 'src/types/OurPressDataType'
import ButtonCircleWithChevron from 'src/components/shared/ButtonCircleWithChevron'
import { textFactory } from 'src/locale/textFactory'
import { useContext, useEffect, useRef, useState } from 'react'
import { LocaleContext } from 'src/contexts/contextapi'

export default function MainOurPress() {
  const text = textFactory()
  const { locale } = useContext(LocaleContext)
  const slideWindow = useRef<HTMLDivElement>(null)
  const [ position, setPosition ] = useState<number>(0)

  useEffect(() => {
    slideWindow.current?.scrollTo({
      top: 0,
      left: 30,
      behavior: 'smooth'
    })
  }, [])

  const getDeltaPosition = () => {
    const contentBoxWidth = slideWindow.current?.children[0].children[1].getBoundingClientRect().width || 300
    const contentBoxMarginRight = slideWindow.current?.children?.[0]?.children?.[1]
      ? parseInt(window.getComputedStyle(slideWindow.current.children[0].children[1]).getPropertyValue('margin-right').replace('px', '')) || 0
      : 0
    return contentBoxWidth + contentBoxMarginRight
  }

  const moveLeft = () => {
    const deltaPosition = getDeltaPosition()
    const newPosition = Math.max(0, position - deltaPosition)
    slideWindow.current?.scrollTo({
      top: 0,
      left: newPosition,
      behavior: 'smooth'
    })
    setPosition(newPosition)
  }
  const moveRight = () => {
    const deltaPosition = getDeltaPosition()
    const upperLimit = slideWindow.current!.scrollWidth - slideWindow.current!.offsetWidth
    const newPosition = Math.min(upperLimit, position + deltaPosition)
    slideWindow.current?.scrollTo({
      top: 0,
      left: newPosition,
      behavior: 'smooth'
    })
    setPosition(newPosition)
  }

  const firstLayerData = OUR_PRESS_DATA[locale].filter((_, index) => index % 3 === 0)
  const secondLayerData = OUR_PRESS_DATA[locale].filter((_, index) => index % 3 === 1)
  const thirdLayerData = OUR_PRESS_DATA[locale].filter((_, index) => index % 3 === 2)
  
  const createContentBox = (pressData: OurPressDataType, index: number) => (
    <MainOurPressContentBox
      key={ `${pressData.headLine}-${index}` }
      headLine={ pressData.headLine }
      press={ pressData.press }
      onClick={ pressData.onClick }
    />
  )
  return (
    <div className={ styles.MainOurPress }>
      <h2 className={ styles.title }>{ text.MainOurPress_title }</h2>
      <div 
        className={ styles.slideWindow }
        ref={ slideWindow }
      >
        <div className={ `${styles.layerCommon} ${styles.firstLayer}` }>
          { firstLayerData.map(createContentBox) }
          &nbsp;
        </div>
        <div className={ `${styles.layerCommon} ${styles.secondLayer}` }>
          { secondLayerData.map(createContentBox) }
          &nbsp;
        </div>
        <div className={ `${styles.layerCommon} ${styles.thirdLayer}` }>
          { thirdLayerData.map(createContentBox) }
          &nbsp;
        </div>
      </div>
      <div className={ styles.controller }>
        <ButtonCircleWithChevron 
          direction="left"
          onClick={ moveLeft }
        />
        <ButtonCircleWithChevron
          direction="right"
          onClick={ moveRight }
        />
      </div>
    </div>
  )
}
